import { render } from "./PlayTableView.vue?vue&type=template&id=720b866a"
import script from "./PlayTableView.vue?vue&type=script&lang=js"
export * from "./PlayTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/playbooks/PlayTableView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "720b866a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('720b866a', __exports__)) {
    api.reload('720b866a', __exports__)
  }
  
  module.hot.accept("./PlayTableView.vue?vue&type=template&id=720b866a", () => {
    api.rerender('720b866a', render)
  })

}


export default __exports__